import { UUID } from '../../shared/UUID';
import { IOrderTagResponse } from './IOrderTagResponse';
import { convertITagResponseToITagData, ITagData } from '../../tags/ITagData';

export interface IOrderTagData {
  orderId: UUID;
  tag: ITagData;
  value?: string;
}

export const convertIOrderTagResponseToIOrderTagData = ({ orderId, tag, value }: IOrderTagResponse): IOrderTagData => {
  return { orderId, tag: convertITagResponseToITagData(tag), value };
};
